'use strict';
/* eslint no-eval: 0 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var EventEmitter = require('events');

var lmerge = require('lodash.merge');

var io = require('socket.io-client');

var SshControl =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(SshControl, _EventEmitter);

  function SshControl() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SshControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SshControl).call(this));
    _this.options = lmerge({
      foglet: undefined,
      address: 'http://localhost:4000/',
      verbose: true,
      origins: '*'
    }, options);
    _this.signaling = io.connect(_this.options.address, {
      origins: options.origins
    });

    _this.signaling.emit('join', {
      id: _this.options.foglet.id
    });

    _this.signaling.on('remoteCommand', function (command) {
      var parsed;

      _this.log('remoteCommand', command);

      try {
        parsed = eval('(' + command + ')');

        _this.log(parsed);

        _this.deserialize(parsed.command)(_this.options.foglet);
      } catch (e) {
        _this.log(e);
      }
    });

    return _this;
  }

  _createClass(SshControl, [{
    key: "deserialize",
    value: function deserialize(message) {
      return eval('(' + message + ')');
    }
  }, {
    key: "log",
    value: function log(signal, message) {
      if (this.options.verbose && signal !== undefined && message !== undefined) {
        this.emit('logs', signal, message);
      }
    }
  }]);

  return SshControl;
}(EventEmitter);

module.exports = SshControl;